export const classes = {
  sidebar:
    'self-start mb-4 ml-6 mt-[30px] flex flex-col items-center gap-2 rounded-3xl border border-white/70 bg-[linear-gradient(180deg,hsla(26.7,68%,97%,.84),hsla(216,58%,98%,.62)_26%,hsla(280,30%,98%,.8)_78%,hsla(210,40%,97.5%,.84))] px-2 py-3 shadow-aurora-card backdrop-blur-[12px] dark:border-white/[0.14] dark:bg-[linear-gradient(180deg,rgba(255,255,255,.16),rgba(255,255,255,.07))]',
  icon: 'size-5',
};
